import { UPDATE_LIST } from '../actionTypes'

export const updateList = (data: object) => ({
  type: UPDATE_LIST.name,
  api: {
    url: 'guests/update_list',
    data: data,
  },
})
